export const COMPANY_NAME_LABEL = '会社名';
export const DEPARTMENT_NAME_LABEL = '部署';
export const STAFF_NAME_LABEL = '担当者名';
export const NAME_LABEL = '氏名';
export const EMAIL_LABEL = 'メールアドレス';
export const PHONE_LABEL = '電話番号';
export const PASSWORD_LABEL = 'パスワード';
export const PASSWORD_CONFIRM_LABEL = 'パスワード確認用';
export const REQUIRED_LABEL = '必須';

// 企業一覧関連
export const COMPANY_LIST_TITLE = '企業一覧';
export const COMPANY_LIST_REGISTRATION_COUNT = '登録数：';
export const COMPANY_LIST_REGISTRATION_COUNT_ALL = '社';
export const COMPANY_LIST_INVITE_BUTTON = '企業を招待する';
export const COMPANY_LIST_SEARCH_PLACEHOLDER = '企業名で検索';
export const COMPANY_LIST_PLAN_SELECT_PLACEHOLDER = 'プランを選択';
export const COMPANY_LIST_CLEAR_BUTTON = '検索クリア';
export const COMPANY_LIST_NO_DATA = '企業データが見つかりませんでした';
export const COMPANY_LIST_ERROR_FETCH = '企業データの取得に失敗しました';

// 企業一覧テーブルヘッダー
export const COMPANY_TABLE_HEADER_NAME = '企業名';
export const COMPANY_TABLE_HEADER_STATUS = 'ステータス';
export const COMPANY_TABLE_HEADER_PLAN = '契約プラン';
export const COMPANY_TABLE_HEADER_CREATED_AT = '登録日';
export const COMPANY_TABLE_HEADER_USAGE_COUNT = '利用枚数';
export const COMPANY_TABLE_HEADER_PATTERN_COUNT = '読取パターン数';
export const COMPANY_TABLE_HEADER_STAFF_COUNT = '担当者数';
export const COMPANY_TABLE_HEADER_INVITED_EMAIL = '招待メールアドレス';

// 企業プラン名
export const COMPANY_PLAN_FREE = 'フリー';
export const COMPANY_PLAN_STANDARD = 'スタンダード';
export const COMPANY_PLAN_PRO = 'プロ';
export const COMPANY_PLAN_CUSTOM = 'オーダーメード';
export const COMPANY_PLAN_UNKNOWN = '不明';

// 企業ステータス名
export const COMPANY_STATUS_INVITED = '招待中';
export const COMPANY_STATUS_ACTIVE = '有効';
export const COMPANY_STATUS_SUSPENDED = '利用停止中';
export const COMPANY_STATUS_DELETED = '削除';
export const COMPANY_STATUS_UNKNOWN = '不明';

// ユーザー役職名
export const USER_ROLE_OPERATOR_ADMIN = '運営管理者';
export const USER_ROLE_OPERATOR = '運営オペレーター';
export const USER_ROLE_COMPANY_ADMIN = '管理者';
export const USER_ROLE_COMPANY_MEMBER = 'メンバー';
export const USER_ROLE_UNKNOWN = '不明';

// OCRクレジット追加関連
export const OCR_CREDIT_ADD_TITLE = 'OCRクレジット追加';
export const OCR_CREDIT_ADD_CREDIT_LABEL = 'OCRクレジット';
export const OCR_CREDIT_ADD_NOTE_LABEL = '備考';
export const OCR_CREDIT_ADD_BACK_BUTTON = '戻る';
export const OCR_CREDIT_ADD_CONFIRM_BUTTON = '確認';
export const OCR_CREDIT_ADD_CONFIRM_DIALOG_TITLE = 'OCRクレジット追加確認';
export const OCR_CREDIT_ADD_CONFIRM_DIALOG_CANCEL = 'キャンセル';
export const OCR_CREDIT_ADD_CONFIRM_DIALOG_SUBMIT = '追加する';
export const OCR_CREDIT_ADD_ERROR_NOT_FOUND = '指定された企業が見つかりませんでした。';
export const OCR_CREDIT_ADD_ERROR_UPDATE =
  'OCRクレジット追加に失敗しました。時間をおいて再度お試しください。';
export const OCR_CREDIT_ADD_BACK_TO_LIST = '企業一覧に戻る';
export const OCR_CREDIT_EXPIRES_AT_LABEL = '有効期限';
export const OCR_CREDIT_EXPIRES_AT_NOTE = '※付与日から1年間有効です';

// OCRクレジット追加完了画面関連
export const OCR_CREDIT_ADD_COMPLETE_TITLE = 'OCRクレジット追加完了';
export const OCR_CREDIT_ADD_COMPLETE_MESSAGE = 'OCRクレジットを追加しました';
export const OCR_CREDIT_ADD_COMPLETE_BUTTON = '企業詳細へ';

// 企業詳細画面関連
export const COMPANY_DETAIL_TAB_OVERVIEW = '概要';
export const COMPANY_DETAIL_TAB_WEBHOOK = 'Webhook';
export const COMPANY_DETAIL_PROXY_LOGIN_BUTTON = '代理ログイン';
export const COMPANY_DETAIL_CONTRACT_INFO_TITLE = '契約情報';
export const COMPANY_DETAIL_CONTRACT_PLAN = '契約中のプラン';
export const COMPANY_DETAIL_CONTRACT_PLAN_CHANGE = '変更する';
export const COMPANY_DETAIL_MONTHLY_FEE = '月額費用';
export const COMPANY_DETAIL_CONTRACT_START_DATE = '契約開始日';
export const COMPANY_DETAIL_NEXT_RENEWAL_DATE = '次回更新日';
export const COMPANY_DETAIL_CONTRACT_STATUS = '契約ステータス';
export const COMPANY_DETAIL_USAGE_TITLE = '今月のOCR利用状況';
export const COMPANY_DETAIL_USAGE_COUNT = '利用枚数';
export const COMPANY_DETAIL_MONTHLY_BUDGET_COST = '月間枠消費';
export const COMPANY_DETAIL_CREDIT_COST = 'OCRクレジット消費';
export const COMPANY_DETAIL_OCR_CREDIT = 'OCRクレジット残高';
export const COMPANY_DETAIL_OCR_CREDIT_ADD = '追加する';
export const COMPANY_DETAIL_PROXY_OPERATION = '代理操作枚数';
export const COMPANY_DETAIL_COMPANY_INFO_TITLE = '会社情報';
export const COMPANY_DETAIL_COMPANY_NAME = '企業名';
export const COMPANY_DETAIL_REPRESENTATIVE = '担当代表者';
export const COMPANY_DETAIL_PHONE_NUMBER = '電話番号';
export const COMPANY_DETAIL_REGISTERED_DATE = '登録日';
export const COMPANY_DETAIL_UPDATED_DATE = '最終更新日';
export const COMPANY_DETAIL_CRM_ID = '企業番号';
export const COMPANY_DETAIL_CRM_ID_SAVE_ERROR =
  '企業番号の保存に失敗しました。時間をおいて再度お試しください。';
export const COMPANY_DETAIL_CRM_ID_VALIDATION_ERROR = '英字と数字のみ入力できます。';
export const COMPANY_DETAIL_STATISTICS_TITLE = '統計情報';
export const COMPANY_DETAIL_STAFF_COUNT = '担当者数';
export const COMPANY_DETAIL_STAFF_COUNT_CHANGE = '変更する';
export const COMPANY_DETAIL_PATTERN_COUNT = '読取パターン数';
export const COMPANY_DETAIL_PATTERN_COUNT_CHANGE = '変更する';
// AIマスタ照合レコード数（#3288）
export const COMPANY_DETAIL_MASTER_RECORD_COUNT = 'マスタレコード数';
export const COMPANY_DETAIL_MASTER_RECORD_COUNT_CHANGE = '変更する';
export const COMPANY_DETAIL_MASTER_RECORD_NO_LIMIT = '制限なし';
export const COMPANY_DETAIL_MONTHLY_USAGE_AVG = '一ヶ月あたりの利用枚数';
export const COMPANY_DETAIL_ERROR_FETCH = '企業情報の取得に失敗しました';
export const COMPANY_DETAIL_ERROR_RETRY = '再読み込み';
// オプション機能セクション（#3193・契約情報から分離）
export const COMPANY_DETAIL_OPTION_FEATURE_TITLE = 'オプション機能';
export const COMPANY_DETAIL_OPTION_GROUP_FEATURE = '利用機能';
export const COMPANY_DETAIL_OPTION_GROUP_SECURITY = 'セキュリティ';
export const COMPANY_DETAIL_FEATURE_MASTER = 'マスタ管理機能';
export const COMPANY_DETAIL_FEATURE_DICTIONARY = '辞書変換機能';
export const COMPANY_DETAIL_FEATURE_API = 'API連携機能';
export const COMPANY_DETAIL_FEATURE_WEBHOOK = 'Webhook 機能';
export const COMPANY_DETAIL_FEATURE_EMAIL_IMPORT = 'メール取り込み機能';
export const COMPANY_DETAIL_FEATURE_EXPORT_TEMPLATE = '指定フォーマット出力';
export const COMPANY_DETAIL_FEATURE_CUSTOM_FUNCTIONS = 'カスタム関数';
export const COMPANY_DETAIL_FEATURE_SECURITY_ADDON = 'セキュリティアドオン';
export const COMPANY_DETAIL_FEATURE_IP_RESTRICTION_BYPASS = 'IP制限 一時無効化';
export const COMPANY_DETAIL_FEATURE_SAML_BYPASS = 'SAML必須 一時バイパス';
export const COMPANY_DETAIL_FEATURE_STRIPE = 'Stripe ID設定';
export const COMPANY_DETAIL_FEATURE_CHANGE = '変更する';
export const COMPANY_DETAIL_FEATURE_ENABLED = '有効';
export const COMPANY_DETAIL_FEATURE_DISABLED = '無効';
export const COMPANY_DETAIL_FEATURE_IN_PROGRESS = '準備中です';
export const COMPANY_DETAIL_SUSPENDED_ERROR =
  'この企業は停止中のため、操作を実行できません。先に契約ステータスを有効にしてください。';

// Webhook 設定関連
export const WEBHOOK_PAGE_TITLE = 'Webhook 設定';
export const WEBHOOK_BACK_TO_PATTERN = 'パターン画面に戻る';
export const WEBHOOK_ENABLED_LABEL = 'Webhook を有効にする';
export const WEBHOOK_URL_LABEL = 'エンドポイント URL';
export const WEBHOOK_URL_PLACEHOLDER = 'https://example.com/webhook';
export const WEBHOOK_URL_HTTPS_ERROR = 'HTTPS の URL を指定してください。';
export const WEBHOOK_URL_REQUIRED_ERROR = 'URL を入力してください。';
export const WEBHOOK_EVENTS_LABEL = '購読するイベント';
export const WEBHOOK_EVENTS_REQUIRED_ERROR = 'イベントを 1 つ以上選択してください。';
export const WEBHOOK_SECRET_LABEL = 'シークレット';
export const WEBHOOK_SECRET_LAST4_DESCRIPTION = '末尾 4 桁のみ表示しています。';
export const WEBHOOK_SECRET_ROTATE_BUTTON = '再生成';
export const WEBHOOK_SECRET_PLAINTEXT_TITLE = 'シークレットを表示';
export const WEBHOOK_SECRET_PLAINTEXT_NOTICE =
  'このシークレットは生成直後のこの画面でしか表示されません。安全な場所に保管してください。';
export const WEBHOOK_SECRET_COPY_BUTTON = 'コピー';
export const WEBHOOK_SECRET_COPIED = 'コピーしました。';
export const WEBHOOK_TEST_SEND_BUTTON = 'テスト送信';
export const WEBHOOK_LAST_DELIVERY_TITLE = '最終配信';
export const WEBHOOK_LAST_DELIVERY_NONE = '配信履歴はまだありません。';
export const WEBHOOK_SAVE_BUTTON = '保存する';
export const WEBHOOK_DELETE_BUTTON = '設定を削除';
export const WEBHOOK_DELETE_CONFIRM = 'この Webhook 設定を削除しますか？';
export const WEBHOOK_SAVE_SUCCESS = 'Webhook 設定を保存しました。';
export const WEBHOOK_DELETE_SUCCESS = 'Webhook 設定を削除しました。';
export const WEBHOOK_SAVE_ERROR = 'Webhook 設定の保存に失敗しました。';
export const WEBHOOK_LOAD_ERROR = 'Webhook 設定の読み込みに失敗しました。';
export const WEBHOOK_FEATURE_DISABLED = 'この企業では Webhook 機能が有効化されていません。';
export const WEBHOOK_TEST_SUCCESS = 'テスト送信に成功しました';
export const WEBHOOK_TEST_FAILED = 'テスト送信に失敗しました';

export const WEBHOOK_TEST_ERROR_REASON_LABEL = 'エラー理由';
export const WEBHOOK_DIALOG_CLOSE_BUTTON = '閉じる';

// Webhook 機能トグル
export const WEBHOOK_FEATURE_TITLE = 'Webhook 機能';
export const WEBHOOK_FEATURE_PRO_ONLY_TOOLTIP =
  'Pro / Custom プラン契約済の企業のみ有効化できます。';
export const WEBHOOK_FEATURE_ENABLED_LABEL = '有効';
export const WEBHOOK_FEATURE_DISABLED_LABEL = '無効';
export const WEBHOOK_FEATURE_TOGGLE_ERROR = 'Webhook 機能の切り替えに失敗しました。';
export const WEBHOOK_FEATURE_ENABLED_SUCCESS = 'Webhook 機能を有効化しました。';
export const WEBHOOK_FEATURE_DISABLED_SUCCESS = 'Webhook 機能を無効化しました。';

// セキュリティアドオン（#2982-2985）運営トグル
export const SECURITY_ADDON_TITLE = 'セキュリティアドオン';
export const SECURITY_ADDON_TOGGLE_ERROR = 'セキュリティアドオンの切り替えに失敗しました。';
export const SECURITY_ADDON_ENABLED_SUCCESS = 'セキュリティアドオンを有効化しました。';
export const SECURITY_ADDON_DISABLED_SUCCESS = 'セキュリティアドオンを無効化しました。';
export const IP_RESTRICTION_BYPASS_TOGGLE_ERROR = 'IP制限の一時無効化の切り替えに失敗しました。';
export const IP_RESTRICTION_BYPASS_ENABLED_SUCCESS = 'IP制限を一時無効化しました。';
export const IP_RESTRICTION_BYPASS_DISABLED_SUCCESS = 'IP制限の一時無効化を解除しました。';

// SAML 必須モードの一時バイパス（#2983）運営トグル
export const SAML_MODE_BYPASS_TITLE = 'SAML必須 一時バイパス';
export const SAML_MODE_BYPASS_TOGGLE_ERROR = 'SAML必須バイパスの切り替えに失敗しました。';

// 読取パターン一覧 行アクション
export const PATTERN_LIST_COPY_BUTTON = 'コピー';
export const PATTERN_LIST_DETAIL_BUTTON = '詳細';
export const PATTERN_LIST_MENU_LABEL = '操作メニューを開く';
export const PATTERN_LIST_MENU_ACCURACY = '精度確認';
export const PATTERN_LIST_MENU_EDIT_HISTORY = '編集履歴';
export const PATTERN_LIST_MENU_WEBHOOK = 'Webhook 設定';
export const PATTERN_LIST_MENU_DELETE = '削除';

// パターン編集履歴／精度確認 画面タイトル
export const PATTERN_ACCURACY_PAGE_TITLE = 'パターン精度確認';
export const PATTERN_EDIT_HISTORY_PAGE_TITLE = 'パターン編集履歴';

// パターン編集履歴／精度確認 空状態テキスト（役割別に出し分け）
export const PATTERN_ACCURACY_EMPTY_TEXT = '編集履歴・OCR実行履歴がまだありません';
export const PATTERN_EDIT_HISTORY_EMPTY_TEXT = '編集履歴がまだありません';

// 代理ログイン関連
export const PROXY_LOGIN_DIALOG_TITLE = '代理ログインの確認';
export const PROXY_LOGIN_BUTTON = '代理ログイン';
export const PROXY_LOGIN_RESTRICTED_MESSAGE = '代理モード中はこの画面を利用できません。';
export const PROXY_RESTRICTED_OPERATION_MESSAGE = '代理モードではこの操作はできません';
export const PROXY_DISPLAY_NAME = '事務局';

// Pro バッジの説明（#3206）。「Pro プラン」と混同されやすいため、
// このバッジが「読み取りに使う AI モデルを選べるパターン」を指すことを補足する。
export const PATTERN_MODEL_SELECTABLE_TOOLTIP = 'AIモデル選択可';

// 運営が検証UIでOCRエンジン・構造化エンジン等を既定から変えて実行した結果のモデル表記（#3206）。
// ユーザーが同じ条件でアップロードしても再現できないため、具体的なモデル名は出さずに
// 「運営が個別に設定した」ことだけを伝える。
// Gemini モデルの変更（Flash→Pro）はユーザーも選べるため、この表記の対象にしない。
export const MODEL_OPERATOR_CUSTOM_LABEL = '事務局指定';
// 共有された ?proxy= 付きURLの異常系メッセージ（#3203）
export const PROXY_COMPANY_NOT_FOUND_MESSAGE =
  '指定された企業が見つかりません。URLをご確認ください。';
export const PROXY_ALREADY_ACTIVE_MESSAGE =
  '現在ほかの企業で代理モード中のため、このリンクは開けません。代理モードを終了してから、もう一度リンクを開いてください。';
export const PROXY_BANNER_HEIGHT = 60;
// 代理バナーとダイアログの間隔（#3310）。16px では窮屈だったため広げる。
export const PROXY_DIALOG_GAP = 24;
export const PROXY_DIALOG_MARGIN_TOP = `${PROXY_BANNER_HEIGHT + PROXY_DIALOG_GAP}px`;
export const CANCEL_BUTTON = 'キャンセル';

// グループ機能（#2804）。複数画面で共通利用するラベル・メッセージ
export const GROUP_MANAGEMENT_TITLE = 'グループ管理';
export const GROUP_CREATE_TITLE = 'グループを作成';
export const GROUP_EDIT_TITLE = 'グループを編集';
export const GROUP_EMPTY_MESSAGE = 'グループがありません';
// 一覧テーブルの列見出し（パターン一覧・担当者一覧で共通）
export const GROUP_COLUMN_LABEL = 'グループ';
// 読取パターン一覧の共有範囲列の見出し（全体/グループ/担当者を包含。#2963）
export const SHARE_SCOPE_COLUMN_LABEL = '共有範囲';

// メニュー・画面見出し・タイトルで共通利用するラベル（重複リテラルの定数化 #2899）
export const ACCOUNT_MANAGEMENT_TITLE = 'アカウント管理';
export const STAFF_LIST_TITLE = '担当者一覧';

// 詳細モード（#3069）。運営スタッフ向けの内部情報（コスト・削除済み等）の表示切替
export const DETAIL_MODE_MENU_LABEL = '詳細表示';

// 自動仕分のヘルプリンク（ホーム・パターン作成で共通利用 #2826）
export const AUTO_CLASSIFY_HELP_LABEL = '自動仕分とは';

// メール取り込みの添付ファイル制限ヘルプリンク（#2965）。対応形式・ファイル数・サイズ・ページ数の説明ページへ誘導
export const EMAIL_ATTACHMENT_HELP_LABEL = '対応ファイル・容量について';

// OCR利用状況（#3146）。サイドバーと企業アカウント画面（/company）で共通利用する
// ラベルは項目名のみとし、「残高」は値側（ocrUsageDisplay）に持たせて月間OCRと表記を揃える
export const OCR_USAGE_MONTHLY_LABEL = '月間OCR';
export const OCR_USAGE_MONTHLY_USAGE_LABEL = '今月の利用実績';
export const OCR_USAGE_CREDIT_LABEL = 'OCRクレジット';
